export const TASK_STATUS = {
	PLANNED: 'planned',
	READY: 'ready',
	IN_PROGRESS: 'in progress',
	TESTING: 'testing',
	COMPLETE: 'complete',
	BLOCKED: 'blocked',
	WAITING: 'waiting'
}

export const TASK_STATUS_OPTIONS = [
	{
		value: 'planned',
		display: 'Planned'
	},
	{
		value: 'ready',
		display: 'Ready'
	},
	{
		value: 'in progress',
		display: 'In Progress'
	},
	{
		value: 'testing',
		display: 'Testing'
	},
	{
		value: 'complete',
		display: 'Complete'
	},
	{
		value: 'blocked',
		display: 'Blocked'
	},
	{
		value: 'waiting',
		display: 'Waiting on Client'
	}
]

export const TASK_STATUS_COLOR = {
	'planned': '#7A7B7A',
	'ready': '#FE6464',
	'in progress': '#FE9764',
	'testing': '#FEFE64',
	'complete': '#A7FE64',
	'blocked': '#000000',
	'waiting': '#D8D8D7',
}

export const PMDNDTypes = {
	BACKGROUND: "background",
	WINDOW: "window"
}

export const WIN_SIZE_MIN = 60;


// WEBPACK FOOTER //
// ./src/components/scaffold/constants.js